import React, { useMemo } from 'react';
import { Table, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { CockpitRow } from '../../../../services/devApi';
import { cellText } from './helpers';

interface Props {
  rows: CockpitRow[];
}

/** rows 展開明細：columns 動態從第一列 keys 生成 */
const RowsTable: React.FC<Props> = ({ rows }) => {
  const columns: ColumnsType<CockpitRow> = useMemo(() => {
    if (rows.length === 0) return [];
    return Object.keys(rows[0]).map((key) => ({
      title: <span className="font-mono">{key}</span>,
      dataIndex: key,
      key,
      ellipsis: true,
      render: (v: unknown) => (
        <span className="font-mono" style={{ fontSize: 12 }}>
          {cellText(v)}
        </span>
      ),
    }));
  }, [rows]);

  if (rows.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="沒有資料列" />;
  }

  return (
    <Table<CockpitRow>
      columns={columns}
      dataSource={rows.map((r, i) => ({ ...r, __rowKey: i }))}
      rowKey="__rowKey"
      size="small"
      pagination={rows.length > 10 ? { pageSize: 10, size: 'small' } : false}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default RowsTable;
